import buildRoute from './buildRoute'

export const getSignalOrder = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'signal-order',
            data: formData,
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const postSignalOrder = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'signal-order-post',
            data: formData,
        })
        if (res) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}
